import {Component, Inject} from '@angular/core';
import {ModalComponent} from '../modal/modal.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {FieldType} from '@ngx-formly/core';
interface IImage {
  image_path: string;
  image_id: number;

}

@Component({
  selector: 'lib-image',
  template: `
    <div class="xxx"> test message</div>

    <div *ngIf="image.image_path else uploadImage">
    <img [src]="image.image_path" alt="" style="width: 100%">
    <div>
      <button type="button"  class=" btn  btn-outline-danger"   style="margin-top: 3px; width: 100%"   (click)="onRemoveCurrentImage()">
        <mat-icon style="width: auto" aria-hidden="false" aria-label="Example home icon">delete
        </mat-icon>
      </button>
    </div>
  </div>

  <ng-template #uploadImage>

    <div class="featuredImage" (click)="imageModal()" >
      <mat-icon>cloud_upload</mat-icon>
      <span>Изображение поста </span>
    </div>
  </ng-template>
  `,
  styleUrls: ['./image.component.css']
})

export class ImageComponent extends FieldType {
  imagePath: string;
  dialogConfig = new MatDialogConfig();
  staticUrl: string;
  image: IImage = {
    image_path: null,
    image_id: null
  };

  constructor(public dialog: MatDialog, @Inject('config') config) {
    super();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.data = {multiple: false};
    this.dialogConfig.height = '470';
    this.dialogConfig.width = '70%';
    this.staticUrl = config.staticUrl;

  }

  imageModal(): void {
    this.dialogConfig.data = {multiple: false};
    const dialogRef = this.dialog.open(ModalComponent, this.dialogConfig);
    dialogRef.componentInstance.OnImages.subscribe(([modalData]) => {
      const image = {
        image_id: modalData.id,
        image_path: this.staticUrl + '/' + modalData.path
      };
      this.field.model.image = image;
      this.image = image;

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });


  }

  onRemoveCurrentImage(): void {
    this.field.model.image = null;
    this.image.image_id = null;
    this.image.image_path = null;
  }

}
